import React from 'react';
import styled from 'styled-components';
import Icon from '../../atoms/Icon';

// This file contains all the icons of the project: place the component in App.js to show them

const IconWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  & span {
    padding: 10px;
    display: block;
  }
`;

const Icons = () => (
  <>
    <div style={{ padding: '20px' }}>Icons:</div>
    <IconWrapper>
      <Icon type="icon icon-alert" size={30} />
      <Icon type="icon icon-shape" size={30} />
      <Icon type="icon icon-mail" size={30} />
      <Icon type="icon icon-down" size={30} />
      <Icon type="icon icon-mappamondo" size={30} />
      <Icon type="icon icon-delete" size={30} />
      <Icon type="icon icon-assistance-hr" size={30} />
      <Icon type="icon icon-people" size={30} />
      <Icon type="icon icon-completato" size={30} />
      <Icon type="icon icon-close" size={30} />
      <Icon type="icon icon-commenti" size={30} />
      <Icon type="icon icon-download" size={30} />
      <Icon type="icon icon-torna-su" size={30} />
      <Icon type="icon icon-document" size={30} />
      <Icon type="icon icon-info" size={30} />
      <Icon type="icon icon-heart-empty" size={30} />
      <Icon type="icon icon-notifiche" size={30} />
      <Icon type="icon icon-profilo" size={30} />
      <Icon type="icon icon-select-negativo" size={30} />
      <Icon type="icon icon-share" size={30} />
      <Icon type="icon icon-play" size={30} />
      <Icon type="icon icon-views" size={30} />
      <Icon type="icon icon-home" size={30} />
      <Icon type="icon icon-badge" size={30} />
      <Icon type="icon icon-calendar" size={30} />
      <Icon type="icon icon-clock" size={30} />
      <Icon type="icon icon-corsi" size={30} />
      <Icon type="icon icon-dashboard" size={30} />
      <Icon type="icon icon-decrease" size={30} />
      <Icon type="icon icon-discussioni" size={30} />
      <Icon type="icon icon-grow" size={30} />
      <Icon type="icon icon-help" size={30} />
      <Icon type="icon icon-locked" size={30} />
      <Icon type="icon icon-logout" size={30} />
      <Icon type="icon icon-punteggio-alto" size={30} />
      <Icon type="icon icon-punteggio-basso" size={30} />
      <Icon type="icon icon-punteggio-medio-1" size={30} />
      <Icon type="icon icon-search" size={30} />
      <Icon type="icon icon-totalearticoli" size={30} />
      <Icon type="icon icon-nonutile" size={30} />
      <Icon type="icon icon-like" size={30} />
      <Icon type="icon icon-left" size={30} />
      <Icon type="icon icon-right" size={30} />
      <Icon type="icon icon-logo" size={30} />
      <Icon type="icon icon-preferiti" size={30} />
      <Icon type="icon icon-check" size={30} />
      <Icon type="icon icon-finanzia" size={30} />
      <Icon type="icon icon-pencil" size={30} />
      <Icon type="icon icon-star-empty" size={30} />
      <Icon type="icon icon-star-full" size={30} />
      <Icon type="icon icon-discover" size={30} />
      <Icon type="icon icon-camera" size={30} />
      <Icon type="icon icon-setting" size={30} />
      <Icon type="icon icon-sun" size={30} />
      <Icon type="icon icon-moon" size={30} />
      <Icon type="icon icon-sphere" size={30} />
      <Icon type="icon icon-location" size={30} />
      <Icon type="icon icon-reload" size={30} />
      <Icon type="icon icon-activities" size={30} />
      <Icon type="icon icon-wiindow-new" size={30} />
    </IconWrapper>
  </>
);

export default Icons;
